/** 允许上传的文件类型（空数组表示接受所有类型） */
export const ALLOWED_MIME_TYPES: string[] = [];

/** 允许上传的文件类型字符串 */
export const ALLOWED_MIME_TYPES_STRING = ALLOWED_MIME_TYPES.length > 0 ? ALLOWED_MIME_TYPES.join(',') : '*/*';

/**
 * 上传服务配置
 */
export interface UploadServiceConfig {
  /** 获取 API 基础 URL */
  getApiBaseUrl: () => string;
}

/** 最大文件大小限制（5MB） */
export const MAX_FILE_SIZE = 5 * 1024 * 1024;

/** 最大文件数量限制 */
export const MAX_FILE_COUNT = 5;

/**
 * 默认上传目录
 */
export const DEFAULT_UPLOAD_DIR = 'file';

/**
 * 上传路径前缀
 */
export const UPLOAD_PATH_PREFIX = 'assets/onepage';

/**
 * 上传目录枚举
 */
export enum UploadDir {
  Image = 'img',
  ImageAttachment = 'img/attachment',
  Icon = 'thread/icon',
  File = 'file',
  FileAttachment = 'file/attachment',
}
